import { motion, useReducedMotion } from "framer-motion";

// Block-level reveal: opacity + a gentle upward move + a subtle scale.
// Animates ONCE, respects prefers-reduced-motion, and never splits text
// (the whole child block is animated → fully translation-safe).
//
// `immediate` — animate as soon as the block mounts, without waiting for it to
// scroll into view. Use it for ABOVE-THE-FOLD hero content: it is visible from
// the start, so gating it behind an IntersectionObserver could leave the text
// and icons hidden until the first scroll (notably after a client-side route
// change). Everything below the fold keeps the default scroll-triggered reveal.
export const Reveal = ({
  children,
  className = "",
  delay = 0,
  y = 24,
  scale = true,
  once = true,
  amount = 0.2,
  duration = 0.9,
  immediate = false,
}) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return <div className={className}>{children}</div>;
  }

  const shown = { opacity: 1, y: 0, scale: 1 };
  const inViewProps = immediate
    ? { animate: shown }
    : { whileInView: shown, viewport: { once, amount } };

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, scale: scale ? 0.985 : 1 }}
      {...inViewProps}
      transition={{ duration, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
};
